import React from 'react';
import { List, ListItem, ListItemText, Typography } from '@material-ui/core';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import Meta from '@bizapp-lp/workflow/organisms/Meta';
import {
  ComplexMarketoForm,
  ComplexMarketoFormProps,
} from '@bizapp-lp/workflow/templates/ComplexMarketoForm';

export interface DocumentClaimProps
  extends Pick<ComplexMarketoFormProps, 'marketoForm'> {
  grecaptchaKey?: string;
}

const title =
  'Workflow 資料請求 | ノーコードで現場で簡単に利用することができるワークフローサービス';
const description =
  '株式会社ワークスアプリケーションズ・エンタープライズがご提供する、Workflow 資料請求ページです。';

const DocumentClaim: React.FC<DocumentClaimProps> = (props) => {
  const complexFormProps: ComplexMarketoFormProps = {
    title: (
      <>
        <span>Workflow</span>
        <span>資料ダウンロード</span>
      </>
    ),
    subtitle:
      'HUE Works Suite Workflowにご興味をお持ちいただきありがとうございます。Workflowの導入検討にお役立ていただける各種資料をご用意しております。',
    imgSrc: `${process.env.PUBLIC_URL}/images/workflow-dlfiles_w.png`,
    imgAlt: 'ダウンロード資料',
    article: (
      <>
        <Typography variant="body1">
          以下内容の資料をダウンロードいただけます。
        </Typography>
        <List component="ul">
          <ListItem disableGutters>
            <ListItemText>
              Workflowご紹介資料（特長/料金プランなど）
            </ListItemText>
          </ListItem>
        </List>
        <Typography variant="body1">
          弊社サービスのご紹介資料をご用意しております。ぜひご活用ください。
        </Typography>
      </>
    ),
    children: (
      <>
        <span>{'下記フォームにご記入ください。'}</span>
        <span>{'フォーム送信後、ダウンロード画面へ移動します。'}</span>
      </>
    ),
    marketoForm: props?.marketoForm,
  };

  return (
    <GoogleReCaptchaProvider reCaptchaKey={props?.grecaptchaKey}>
      <Meta>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Meta>
      <ComplexMarketoForm {...complexFormProps} />
    </GoogleReCaptchaProvider>
  );
};

export default DocumentClaim;
